import { useTranslation } from "react-i18next";
import TextInput from "../../inputs/textInput";

const Step2Form = ({ formik }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <TextInput
        formik={formik}
        placeholder={t("fullName")}
        label={t("fullName")}
        name={"fullName"}
      />
      <TextInput
        formik={formik}
        placeholder={t("jobPosition")}
        label={t("jobPosition")}
        name={"jobPosition"}
      />
      <TextInput
        formik={formik}
        placeholder={t("personalPhone")}
        label={t("personalPhone")}
        name={"personalPhone"}
      />
      <TextInput
        formik={formik}
        placeholder={t("personalEmail")}
        label={t("personalEmail")}
        name={"personalEmail"}
      />
    </div>
  );
};

export default Step2Form;
